/* GearMustHave recently-viewed — honest, localStorage-backed (mirrors the wishlist storage approach).
 * Records the current product HANDLE on each product view, then renders the rest as cards fetched
 * per handle via /products/{handle}?section_id=recently-viewed-card. Cards are server-rendered so
 * price / editorial score / affiliate button are correct and market-safe (no hand-built money
 * formatting). The section stays hidden until >=1 card renders (no empty state on the storefront);
 * in the theme editor it reveals a placeholder note so the merchant can place/style it. */
(function () {
  var KEY = 'gmh_recently_viewed';
  var CAP = 20;

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage blocked (private mode) — history just won't persist */
    }
  }
  function record(handle) {
    if (!handle) return;
    var list = read().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle); // most-recent first
    if (list.length > CAP) list = list.slice(0, CAP);
    write(list);
  }

  if (!customElements.get('gmh-recently-viewed')) {
    customElements.define(
      'gmh-recently-viewed',
      class extends HTMLElement {
        connectedCallback() {
          this.current = this.dataset.handle || '';
          this.limit = parseInt(this.dataset.limit, 10) || 4;
          this.cardSection = this.dataset.cardSection;
          // Normalize to no trailing slash so `root + '/products/'` is correct whether root_url is
          // '/' (primary locale) or '/fr' (secondary locale) — avoids a '/frproducts/' 404.
          this.root = (this.dataset.root || '/').replace(/\/$/, '');
          this.grid = this.querySelector('[data-rv-grid]');
          this.placeholder = this.querySelector('[data-rv-placeholder]');
          this.isEditor = !!(window.Shopify && window.Shopify.designMode);
          record(this.current); // record this product view (no-op when handle is blank)
          this.render();
        }

        render() {
          var self = this;
          if (!this.grid) return;
          var handles = read()
            .filter(function (h) {
              return h && h !== self.current; // never show the product you're already on
            })
            .slice(0, this.limit);
          if (handles.length === 0) {
            this.empty();
            return;
          }

          Promise.all(
            handles.map(function (h) {
              return fetch(self.root + '/products/' + encodeURIComponent(h) + '?section_id=' + self.cardSection)
                .then(function (r) {
                  return r.ok ? r.text() : '';
                })
                .catch(function () {
                  return ''; // transient failure — just skip this card
                });
            })
          ).then(function (htmls) {
            var frag = document.createDocumentFragment();
            var shown = 0;
            htmls.forEach(function (html) {
              if (!html) return;
              var item = new DOMParser().parseFromString(html, 'text/html').querySelector('.grid__item');
              if (item) {
                frag.appendChild(item);
                shown += 1;
              }
            });
            if (shown === 0) {
              self.empty();
              return;
            }
            self.grid.innerHTML = '';
            self.grid.appendChild(frag);
            self.classList.add('is-ready');
            if (self.placeholder) self.placeholder.hidden = true;
          });
        }

        empty() {
          // Storefront: stay hidden (no empty section). Editor: reveal with a note so it can be placed.
          if (this.isEditor) {
            this.classList.add('is-ready');
            if (this.placeholder) this.placeholder.hidden = false;
          }
        }
      }
    );
  }
})();
